import React from 'react/addons';
import {FluxMixin} from 'fluxxor';
import {gettext} from 'ofs/i18n';
import RatesGuideModal from './RatesGuideModal';

const messages = {
  RATES_QUESTION: gettext("Read about our rates."),
};

const RatesGuide = React.createClass({
  mixins: [
    FluxMixin(React)
  ],

  handleModalClick() {
    this.getFlux().actions.layers.addModal(<RatesGuideModal />);
  },

  render() {
    return (
      <div className="ofs-InfoTip" onClick={this.handleModalClick}>
        <span className="ofs-InfoTip__Label">{messages.RATES_QUESTION}</span>
      </div>
    );
  }
});

module.exports = RatesGuide;




/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/rates-guide.jsx
 **/